import React, { useEffect, useState } from "react";
import Select from "react-select";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const getActioncardSetNumber = (item) => item?.actioncard_set_number || "";

const selectMenuStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 1200 }),
  menu: (base) => ({ ...base, zIndex: 1200 }),
};

const ActioncardsSetEditModal = ({
  show,
  editingItem,
  businessUnitOptions,
  locationOptions,
  optionsLoading,
  saving,
  onClose,
  onSave,
}) => {
  const [actionCardSets, setActionCardSets] = useState("");
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  useEffect(() => {
    if (!show) return;

    setActionCardSets(
      editingItem ? `${getActioncardSetNumber(editingItem)}` : ""
    );
    setSelectedBusinessUnits(
      editingItem
        ? (editingItem.business_units || [])
            .map((id) =>
              businessUnitOptions.find(
                (option) => String(option.value) === String(id)
              )
            )
            .filter(Boolean)
            .slice(0, 1)
        : []
    );
    setSelectedLocations(
      editingItem
        ? (editingItem.locations_units || [])
            .map((id) =>
              locationOptions.find(
                (option) => String(option.value) === String(id)
              )
            )
            .filter(Boolean)
            .slice(0, 1)
        : []
    );
  }, [businessUnitOptions, editingItem, locationOptions, show]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const actionCardSetValues = actionCardSets
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);

    if (!actionCardSetValues.length) {
      toast.error("Please enter actioncard set number");
      return;
    }

    if (!selectedBusinessUnits.length) {
      toast.error("Please select business unit");
      return;
    }

    if (!selectedLocations.length) {
      toast.error("Please select location");
      return;
    }

    onSave({
      action_card_sets: actionCardSetValues,
      business_unit: selectedBusinessUnits.map((item) => item.value),
      locations_units: selectedLocations.map((item) => item.value),
    });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[1050] flex items-center justify-center bg-black/50 px-3">
      <div className="w-full max-w-md rounded-[6px] bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
          <h5 className="m-0 text-base font-semibold text-gray-900">
            Edit Actioncards Set
          </h5>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            aria-label="Close"
            className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-black bg-white p-0 hover:bg-gray-100"
          >
            <FaTimes size={14} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-3 px-4 py-3">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Actioncard Set Number
              </label>
              <input
                type="text"
                className="form-control h-auto rounded-[4px] px-3 py-2 text-sm"
                value={actionCardSets}
                onChange={(event) => setActionCardSets(event.target.value)}
                placeholder="1001-1010"
                disabled={true}
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Business Unit
              </label>
              <Select
                options={businessUnitOptions}
                value={selectedBusinessUnits[0] || null}
                onChange={(value) =>
                  setSelectedBusinessUnits(value ? [value] : [])
                }
                isDisabled={saving || optionsLoading}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : undefined
                }
                menuPosition="fixed"
                styles={selectMenuStyles}
                placeholder="Business unit"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Location
              </label>
              <Select
                options={locationOptions}
                value={selectedLocations[0] || null}
                onChange={(value) => setSelectedLocations(value ? [value] : [])}
                isDisabled={saving || optionsLoading}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : undefined
                }
                menuPosition="fixed"
                styles={selectMenuStyles}
                placeholder="Location"
              />
            </div>
          </div>

          <div className="flex justify-end gap-2 border-t border-gray-200 px-4 py-3">
            <button
              type="button"
              className="btn btn-sm btn-secondary px-3"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-sm bg_color px-3"
              disabled={saving}
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActioncardsSetEditModal;
